import * as PIXI from 'pixi.js'

class Scene1 {
  constructor (game) {
    this.game = game
  }

  enter () {
    this.textures = {
      text1: PIXI.Texture.from('scene1Text'),
      btnSecret: PIXI.Texture.from('btnSecret')
    }

    this.text1 = new PIXI.Sprite(this.textures.text1)
    this.text1.scale.set(0.25)
    this.text1.x = (this.game.app.renderer.realWidth - this.text1.width) / 2
    this.text1.y = 59

    this.btnSecret = new PIXI.Sprite(this.textures.btnSecret)
    this.btnSecret.scale.set(0.25)
    this.btnSecret.x = (this.game.app.renderer.realWidth - this.btnSecret.width) / 2
    this.btnSecret.y = 491

    this.game.app.stage.addChild(
      this.text1,
      this.btnSecret
    )

    this.anime = TweenMax.to(this.btnSecret, 0.4, {
      pixi: {
        y: 486
      },
      yoyo: true,
      repeat: -1
    })
  }

  leave () {
    this.game.app.stage.removeChild(
      this.text1,
      this.btnSecret
    )

    this.text1.destroy()
    this.btnSecret.destroy()

    this.text1 = null
    this.btnSecret = null

    if (this.anime) {
      TweenMax.killTweensOf(this.anime)
    }
  }
}

export default Scene1
